module.exports = __webpack_public_path__ + "static/media/logo-page2.1b605051.png";